(function () {
	const iconElementContaienrs = document.querySelectorAll('.home-icon__row .icon-container');
	const headings = document.querySelectorAll('.home-icon__row h2');
	console.log('iconElementContaienrs', iconElementContaienrs);
	if (
		iconElementContaienrs === null ||
		iconElementContaienrs === undefined ||
		iconElementContaienrs.length === 0
	) {
		return;
	}

	console.dir(iconElementContaienrs);

	Array.from(iconElementContaienrs).forEach((iconContainer, index) => {
		const iconItems = iconContainer.querySelectorAll('.icon-item');

		console.log(iconContainer);
		console.log(headings);
		gsap.from(iconItems, {
			duration: 0.3,
			delay: 0.5,
			x: -50,
			autoAlpha: 0,
			stagger: 0.2,
			scrollTrigger: {
				trigger: iconContainer,
				// toggleActions: 'play restart restart reverse',
				// start: 'top 85%',
				// end: 'bottom 8%',
				// toggleActions: 'play restart restart reverse',
				toggleActions: 'play reverse restart none',
				// start: 'top 85%',
				start: 'top 87%',
				end: 'bottom 19%',
				// markers: true,
			},
		});
		gsap.from(headings[index], {
			duration: 0.3,
			delay: 0.5,
			x: -50,
			autoAlpha: 0,

			scrollTrigger: {
				trigger: iconContainer,
				// toggleActions: 'play restart restart reverse',
				// start: 'top 85%',
				// end: 'bottom 8%',
				// toggleActions: 'play restart restart reverse',
				toggleActions: 'play reverse restart none',
				// start: 'top 85%',
				start: 'top 87%',
				end: 'bottom 19%',
				// markers: true,
			},
		});
	});

	// gsap.from(headings, {
	// 	duration: 0.3,
	// 	delay: 0.5,
	// 	x: -50,
	// 	autoAlpha: 0,
	// 	stagger: 0.2,
	// 	scrollTrigger: {
	// 		trigger: headings,
	// 		toggleActions: 'play reverse restart none',
	// 		start: 'top 87%',
	// 		end: 'bottom 19%',
	// 	},
	// });

	let start = 'top 85%';
	let end = 'bottom 8%';

	// gsap.from(homeHeroCards, {
	// 	duration: 0.3,
	// 	delay: 0.5,
	// 	y: 50,
	// 	autoAlpha: 0,
	// 	stagger: 0.2,
	// 	scrollTrigger: {
	// 		trigger: '.home-hero__cards',
	// 		toggleActions: 'play restart restart reverse',
	// 		start,
	// 		end,
	// 		// markers: true,
	// 	},
	// });
})();
